import { Pipe, PipeTransform } from '@angular/core';

import { contentDateToMilliseconds } from '@resident-nx/shared';

@Pipe({
  name: 'rsWebDate',
  standalone: true,
})
export class DateTransformPipe implements PipeTransform {
  transform(value: string): string {
    const milliseconds = contentDateToMilliseconds(value);
    if (milliseconds === null) {
      return '';
    }

    const dateValue = new Date(milliseconds);
    const day = dateValue.toLocaleDateString('de-DE', { weekday: 'short' });
    const dateNumber = dateValue.toLocaleDateString('de-DE', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });
    return `${day} ${dateNumber}`;
  }
}
